import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, switchMapTo, tap } from 'rxjs/operators';
import { HomeRouteNames } from '../../shared/routing.constants';
import { AuthService } from '../auth/auth.service';
import { UserInfoService } from '../user-info.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private userInfoService: UserInfoService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authService.isAuthenticated().pipe(
      switchMap(isAuthenticated => {
        return !isAuthenticated
          ? this.authService.trySignInFromLocalStorage()
          : of(isAuthenticated);
      }),
      switchMapTo(
        this.userInfoService.isAdmin().pipe(
          tap(isAdmin => {
            if (!isAdmin)
              this.router.navigate([
                HomeRouteNames.ModuleBase,
                HomeRouteNames.Dashboard,
              ]);
          })
        )
      )
    );
  }
}
